const cookieparser = process.server ? require('cookieparser') : undefined
import {logWrapper} from "../utils/logWrapper";

export default function ({$axios, store, req}) {
  $axios.onRequest((config) => {
    if (!process.server) {
      if (!config.url.includes('Dashboard')) {
        store.commit('setLoading', {loading: true})
      }
    }
    if (config.url.includes('refreshtoken')) {
      if (!process.server) {
        try {
          config.data.token = localStorage['auth._token.local'].replace(
            'Bearer ',
            ''
          )
        } catch (err) {
          logWrapper.logError(err);
        }
      }
      if (process.server) {
        if (req.headers.cookie) {
          const parsedCookie = cookieparser.parse(req.headers.cookie)
          try {
            config.data.token = parsedCookie['auth._token.local'].replace(
              'Bearer ',
              ''
            )
          } catch (err) {
            logWrapper.logError(err);
          }
        }
      }
    }
    logWrapper.logInfo('Making request to ' + config.url);
  })

  $axios.onResponse((response) => {
    if (!process.server) {
      store.commit('setLoading', {loading: false})
    }
  })

  $axios.onError((error) => {
    if (!process.server) {
      store.commit('setLoading', {loading: false})
    }
    const code = parseInt(error.response && error.response.status)
    logWrapper.logError(`axios error with code: ${code} - ${error}`)
  })
}
